import { readListParams } from "../shared/listUrlState";

export const CAMPAIGN_STATES = ["all", "active", "paused", "created"];

export const CAMPAIGN_LIST_DEFAULTS = { tab: "all", q: "" };

export const campaignsSourceUrl = (dataSource, state, search) => {
  const params = [];

  if (state !== "all") {
    params.push(`state=${encodeURIComponent(state)}`);
  }

  if (search && search.trim() !== "") {
    params.push(`q=${encodeURIComponent(search.trim())}`);
  }

  const queryString = params.length > 0 ? `?${params.join("&")}` : "";
  return dataSource.split("?")[0] + queryString;
};

export const readCampaignListParams = () => {
  const params = readListParams(CAMPAIGN_LIST_DEFAULTS);
  return CAMPAIGN_STATES.includes(params.tab) ? params : { ...params, tab: CAMPAIGN_LIST_DEFAULTS.tab };
};

export const initialCampaignsSource = (dataSource) => {
  const { tab, q } = readCampaignListParams();
  return campaignsSourceUrl(dataSource, tab, q);
};
